import React from 'react'

export default function GrassBody({ children }) {
  return <div className="user-grass">{children}</div>
}
